import { Fragment, useState, useEffect } from "react";
import styled from "styled-components";
import { SelectBox } from "devextreme-react/select-box";
import { TextBox } from "devextreme-react/text-box";
import { TextArea } from "devextreme-react/text-area";
import { useSelector } from "react-redux";
import RequestTable from "../activityRequestTable/RequestTable";
import DirectCall from "../../Pages/DirectCall";
import { ScrollView } from "devextreme-react";

import Form, {
  SimpleItem,
  GroupItem,
  Label,
  RequiredRule,
} from "devextreme-react/form";
import { Button, Popup } from "devextreme-react";
const OrderContainer = styled.div`
  width: 100%;
  height:98%;
  background: #f8f8f8;
  padding: 10px;
`;
const CustomerContainer = styled.div`
  width: 100%;
  height: 6%;
  ${"" /* border:1px solid; */}
`;
const DemoGraphicContainer = styled.div`
  margin-top: 30px !important;
  height: 10% ${"" /* border-bottom:1px solid lightgrey; */};
`;
const initialValue = {
  dob: "",
  call_source: "",
  customer_id: null,
  call_source_text: "",
  call_context: "",
  call_context_text: "",
  name: "",
  contact: "",
  note: "",
};

const DirectCallOrder = ({ directCallDetails, customStyle }) => {
  const [dataSource, setDataSource] = useState({ ...initialValue });
  console.log("🚀 ~ file: DirectCallOrder.js:43 ~ DirectCallOrder ~ dataSource", dataSource)
  // const { customersList, directCallStaticInfo } = useSelector((state) => state);
  const { operatorAssignedCenters, directCallStaticInfo } = useSelector((state) => state);
  const [caller_type_data, setCallerTypeData] = useState(['Referrer', 'Patient', 'Others'])
  const call_context_referrer = [{ 'name': 'Report Enquiry / Dispatch', 'value': 'REPORT_ENQUIRY_DISPATCH' }, { 'name': 'Talk to Radiologist', 'value': 'TALK_TO_RADIOLOGIST' }, { 'name': 'Urgent Booking', 'value': 'URGENT_BOOKING' }, { 'name': 'Miscellaneous', 'value': 'MISC' }]
  const call_context_patient = [{ 'name': 'Appointment Cancellation', 'value': 'APPOINTMENT_CANCELLATION' }, { 'name': 'Appointment Rescheduling', 'value': 'APPOINTMENT_RESCHEDULING' }, { 'name': 'Report Enquiry', 'value': 'REPORT_ENQUIRY' }, { 'name': 'Address Enquiry', 'value': 'ADDRESS_ENQUIRY' }, { 'name': 'Miscellaneous', 'value': 'MISC' }]



  useEffect(() => {
    if (directCallDetails) {
      setDataSource((prevState) => {
        return {
          ...prevState,
          ...directCallDetails
        }
      })

    }
    return () => {
      setDataSource((prevState) => {
        return {
          ...prevState,
          ...initialValue
        }
      })
    }
  }, [directCallDetails])

  const callSourceTextAreaRender = (call_source) => {
    return (
      <Fragment>
        {call_source === "Miscellaneous" ? (
          <TextBox
            label="Miscellaneous Details"
            labelMode="floating"
            value={dataSource.call_source}

            onValueChange={(value) => {
              // setDataSource((prevState) => {
              //   return {
              //     ...prevState,
              //     call_source_text: value,
              //   };
              // });
            }}
          />
        ) : (
          ""
        )}
      </Fragment>
    );
  };

  const callContextTextAreaRender = (call_context) => {
    return (
      <Fragment>
        {call_context === "Miscellaneous" ? (
          <TextBox
            label="Miscellaneous Details"
            labelMode="floating"
            value={dataSource.call_context}
            onValueChange={(value) => {
              // setDataSource((prevState) => {
              //   return {
              //     ...prevState,
              //     call_context_text: value,
              //   };
              // });
            }}
          />
        ) : (
          ""
        )}
      </Fragment>
    );
  };

  const buttonOptions = {
    text: "Save",
    type: "default",

  };
  const [visible, setVisible] = useState(false)
  const OpenEdit = () => {
    setVisible(!visible)


  }

  return (
    <Fragment>
      {visible === true && <>
        <Popup visible={visible} onHiding={OpenEdit} showTitle={true} title={'Edit Direct call'}>
          <ScrollView width='100%' height='100%'>
        
            <div>
              <DirectCall dataSource={dataSource} center_details={operatorAssignedCenters} OpenEdit={OpenEdit}/>
            </div>
          </ScrollView>
        </Popup>
      </>
      }
      <OrderContainer>
        <CustomerContainer>
          <SelectBox
            label="Center"
            value={dataSource?.center_id?.toString()}
            labelMode="floating"
            displayExpr={"center_name"}
            valueExpr={"center_id"}
            dataSource={operatorAssignedCenters}
            readOnly={true}
            style={{ marginTop: '20px' }}
          />
        </CustomerContainer>
        <DemoGraphicContainer>
          {/* <TextBox label="Name"/> */}
          <Form
            labelMode="floating"
            // ref={formRef}

            formData={dataSource}
          >
            <GroupItem colCount={2} colSpan={2} caption="Call Detail">
              <SimpleItem
                dataField={"call_source"}

              >
                <SelectBox
                  searchEnabled={true}
                  dataSource={caller_type_data}
                  label="Call Type"
                  labelMode="floating"
                  readOnly={true}
                  value={dataSource?.caller_type}
                  onValueChange={(e) => {
                    // setDataSource((prevState) => {
                    //   return {
                    //     ...prevState,
                    //     call_source: e,
                    //   };
                    // });
                  }}
                />
                {/* <RequiredRule/> */}
              </SimpleItem>
              <SimpleItem
                dataField={"call_context"}

              >
                <SelectBox
                  searchEnabled={true}
                  dataSource={dataSource?.caller_type === "Patient" ? call_context_patient : call_context_referrer}
                  displayExpr='name'
                  label="Call Context"
                  labelMode="floating"
                  readOnly={true}
                  valueExpr='value'

                  value={dataSource?.call_context}

                  onValueChange={(e) => {
                    // setDataSource((prevState) => {
                    //   return {
                    //     ...prevState,
                    //     call_context: e,
                    //   };
                    // });
                  }}
                />
                {/* <RequiredRule/> */}
              </SimpleItem>
            </GroupItem>
            <GroupItem colCount={2} colSpan={2} caption="">
              <SimpleItem
                dataField={"caller_name"}
                editorOptions={{ label: "Caller Name", readOnly: true }}
              ></SimpleItem>
              <SimpleItem
                dataField={"patient_dob"}
                visible={dataSource?.caller_type === "Patient" ? true : false}
                editorOptions={{ label: "DOB", displayFormat: "dd/MM/yyyy", readOnly: true }}
                editorType="dxDateBox"
              ></SimpleItem>
              <SimpleItem
                dataField={"caller_number"}
                editorOptions={{ label: "contact", readOnly: true }}
              ></SimpleItem>
            </GroupItem>

            <GroupItem>
              <SimpleItem>
                <Button style={{ width: '80px', height: '30px' }} onClick={OpenEdit}>Edit</Button>
              </SimpleItem>
            </GroupItem>
            <GroupItem>

              <SimpleItem>
                <TextArea label="Notes" style={{ marginTop: '10px' }} placeholder="" readOnly={true} value={dataSource?.call_notes} maxHeight={250} height={250} ></TextArea>

              </SimpleItem>
              <SimpleItem>
                <div style={{ paddingTop: "15px" }}>

                  {directCallDetails.request_log && directCallDetails.request_log.length != 0 && (
                    <RequestTable requestLog={directCallDetails.request_log} />
                  )}
                </div>
              </SimpleItem>
            </GroupItem>

          </Form>

        </DemoGraphicContainer>



      </OrderContainer>

    </Fragment>
  );
};

export default DirectCallOrder;